import { useCallback, useState } from 'react';
import i18n from '../../i18n/i18n';

/**
 * Ant Design Table ile uyumlu, tekrar kullanılabilir pagination hook'u
 * @param defaultPageSize Varsayılan sayfa başı satır sayısı (örn: 20)
 */
export function useTablePagination(defaultPageSize: number = 20) {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(defaultPageSize);

  // Pagination değiştiğinde çağrılır
  const handlePaginationChange = useCallback((page: number, newPageSize?: number) => {
    setCurrentPage(page);
    if (newPageSize && newPageSize !== pageSize) {
      setPageSize(newPageSize);
      // Eğer isterseniz, sayfa boyutu değişince başa dönebilirsiniz:
      // setCurrentPage(1);
    }
  }, [pageSize]);

  // Ant Design Table'a doğrudan verilebilecek props
  const onShowSizeChange = useCallback((_current: number, newSize: number) => {
    if (newSize !== pageSize) {
      setPageSize(newSize);
      setCurrentPage(1);
    }
  }, [pageSize]);

  // Ant Design Table'a doğrudan verilebilecek props
  const getPaginationProps = useCallback((total: number) => ({
    current: currentPage,
    pageSize: pageSize,
    total: total,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100'],
    onChange: handlePaginationChange,
    onShowSizeChange,
    showTotal: (total: number, range: [number, number]) =>
      i18n.t('common.paginationTotal', { from: range[0], to: range[1], total }),
  }), [currentPage, pageSize, handlePaginationChange, onShowSizeChange]);

  return {
    currentPage,
    pageSize,
    setCurrentPage,
    setPageSize,
    handlePaginationChange,
    getPaginationProps,
  };
} 